import React, { useState, useEffect, useRef } from 'react';
import styles from './ThankYou.module.css';

const ThankYou: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    },
    {
      threshold: 0.3,
      rootMargin: '0px'
    }
  );

  const currentRef = sectionRef.current;

  if (currentRef) {
    observer.observe(currentRef);
  }

  return () => {
    if (currentRef) {
      observer.unobserve(currentRef);
    }
  };
}, []);

  return (
    <section className={styles.thankYou} ref={sectionRef}>
      <div className={`${styles.topDecoration} ${isVisible ? styles.fadeIn : ''}`}></div>
      
      <div className="container">
        <div className={styles.thankYouContent}>
          <h3 className={isVisible ? styles.popIn : ''}>
            Gracias por<br />
            acompañarme en<br />
            este día tan especial
          </h3>
          
          <div className={`${styles.heartsDecoration} ${isVisible ? styles.popIn : ''}`}>
            <span>♡</span>
            <span>♡</span>
            <span>♡</span>
          </div>
          
          <p className={`${styles.finalMessage} ${isVisible ? styles.fadeInUp : ''}`}>
            Será un honor compartir contigo<br />
            este momento único en mi vida
          </p>
          
          <div className={`${styles.decorativeDivider} ${isVisible ? styles.expand : ''}`}></div>
          
          <div className={`${styles.signature} ${isVisible ? styles.popIn : ''}`}>
            Carol
          </div>
          
          <p className={`${styles.closingMessage} ${isVisible ? styles.fadeInUp : ''}`}>
            09 · Mayo · 2026
          </p>
        </div>
      </div>
    </section>
  );
};

export default ThankYou;